import { render, staticRenderFns } from "./BottomSheets.vue?vue&type=template&id=2f503978"
import script from "./BottomSheets.vue?vue&type=script&lang=js"
export * from "./BottomSheets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports